import http from '@/http'
import { Model as BaseModel } from 'vue-api-query'

BaseModel.$http = http()

export default class Model extends BaseModel {
  get $http(){
    return http()
  }
  _reqConfig(config){
    if(config.data !== undefined){
      if(config.data._builder){
        delete config.data._builder
      }
    }
    return super._reqConfig(config)
  }

  // Define a base url for a REST API
  baseURL() {
    return `${process.env.VUE_APP_API_URL}/admin`
  }

  // Implement a default request method
  request(config) {
    return this.$http.request(config)
  }
}
